import { createApp } from 'vue';
import App from '@/App.vue';

//Vue Router
import router from '@/router';

//Pinia
import { createPinia } from 'pinia';

//Vue Cookies
import cookies from 'vue-cookies';

//Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import colors from 'vuetify/util/colors';
import '@mdi/font/css/materialdesignicons.css';

//Auth0
import { createAuth0 } from '@auth0/auth0-vue';

const pinia = createPinia();

const vuetify = createVuetify({
    defaults: {
        global: {
            ripple: true,
        },
        VCard: {
            VTextField: {
                variant: 'solo-filled',
                color: 'secondary'
            },
            VSelect: {
                variant: 'solo-filled',
                color: 'secondary'
            },
        },
    },
    theme: {
        themes: {
            light: {
                dark: false,
                colors: {
                    background: colors.grey.lighten3,
                    sfPrimary: '#8F00C7',
                    sfSecondary: '#EA6619',
                    primary: '#8F00C7',
                    secondary: '#EA6619',
                    accent: '#17255A',
                },
            },
            dark: {
                dark: true,
                colors: {
                    sfPrimary: colors.deepPurple.base,
                    sfSecondary: colors.deepOrange.lighten2,
                    primary: colors.deepPurple.base,
                    secondary: colors.deepOrange.lighten2,
                    accent: '#153363',
                },
            },
        },
    },
});

const auth0 = createAuth0({
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
    authorizationParams: {
        audience: process.env.VUE_APP_AUTH0_AUDIENCE,
        redirect_uri: process.env.VUE_APP_AUTH0_REDIRECT_URI,
    },
});

createApp(App)
    .use(router)
    .use(pinia)
    .use(cookies)
    .use(auth0)
    .use(vuetify)
    .mount('#app');
